export default __webpack_public_path__ + "static/media/ana_logo.683373fb.svg";